import { Text } from '@optiaxiom/react';

import { AgentExecutionItem } from '@frontend/types/agentExecution';

import { getTriggerType } from './utils';

type TriggerTypeCellProps = {
  execution: AgentExecutionItem;
};

export function TriggerTypeCell({ execution }: TriggerTypeCellProps) {
  return <Text fontSize="md">{getTriggerType(execution)}</Text>;
}
